// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__ZXUxz","addWidgetButton":"Header_addWidgetButton__2p1OB","dashboardTabs":"Header_dashboardTabs__1Z3dh","active":"Header_active__14LSz"};